import { useMemo } from "react";

interface ForceExitCheckInput {
  isPreApprovalVoid?: boolean;
  readOnly: boolean;
}

interface ForceExitCheckResult {
  shouldForceExit: boolean;
}

/**
 * Computes whether the current deal should trigger a force-exit modal.
 * Force-exit is triggered when isPreApprovalVoid is true and the app is not
 * in read-only mode (analyst holds the VLA lock).
 * @param {ForceExitCheckInput} input - The input parameters.
 * @returns {ForceExitCheckResult} Object with shouldForceExit flag.
 */
export function useForceExitCheck({
  isPreApprovalVoid,
  readOnly,
}: ForceExitCheckInput): ForceExitCheckResult {
  return useMemo(() => {
    if (readOnly) {
      return { shouldForceExit: false };
    }

    const shouldForceExit = isPreApprovalVoid === true;

    return { shouldForceExit };
  }, [isPreApprovalVoid, readOnly]);
}
